import { useTheme } from "@mui/material";
import {
  AudioHTMLAttributes,
  DetailedHTMLProps,
  useEffect,
  useState,
} from "react";
import React from "react";

const EzrAudio = (
  props: DetailedHTMLProps<
    AudioHTMLAttributes<HTMLAudioElement>,
    HTMLAudioElement
  >,
) => {
  const theme = useTheme();

  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [props]);

  return errored ? (
    <div
      style={{
        backgroundColor: theme.palette.divider,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 800,
        color: theme.palette.text.disabled,
        ...props.style,
      }}
    >
      {props.title?.toUpperCase()}
    </div>
  ) : (
    <audio
      {...props}
      onLoadedData={(e) => {
        props.onLoad?.(e);
        e.currentTarget.style.transition = "opacity 200ms ease";

        const target = e.currentTarget;

        setTimeout(
          () => (target.style.transition = props.style?.transition ?? ""),
          200,
        );
      }}
      onError={(e) => {
        console.error("audio error");
        setErrored(true);
        props.onError?.(e);
      }}
      style={{
        ...props.style,
      }}
    />
  );
};

export default EzrAudio;
